import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component, inject, ChangeDetectorRef } from '@angular/core';
import {
    FuseNavigationService,
    FuseVerticalNavigationComponent,
} from '@fuse/components/navigation';
import { Router, RouterLinkActive, RouterModule } from '@angular/router';

import { LinkService } from 'app/_helpers/link-service.service';
import { LogoParrainComponent } from '../logo-parrain/logo-parrain.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { ParrainStore } from 'app/modules/admin/stores/parrain.store';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        MatIconModule,
        MatButtonModule,
        MatDividerModule,
        RouterModule,
        RouterLinkActive,
        LogoParrainComponent
    ],
})
export class FooterComponent {
    private _linkService = inject(LinkService);
    private _fuseNavigationService = inject(FuseNavigationService);
    private _router = inject(Router);
    private _changeDetectorRef = inject(ChangeDetectorRef);

    readonly parrainStore = inject(ParrainStore);

    onClick(url: string) {
        this.sendMessage({ url: url });
        this._linkService.openLinkInNativeView(url);
    }

    sendMessage(data: { url: string }) {
        const message = JSON.stringify(data);
        window.postMessage(message, '*');
    }

    toggleNavigation(name: string): void {
        const navigation =
            this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(
                name
            );
        if (navigation) {
            navigation.toggle();
        }
    }

    onShowParrainSpace(parrainId: string) {
        console.log('Navigation vers partenaire ID:', parrainId);

        this._router.navigate(['/partenaire-detail', parrainId]).then(() => {
            // Tu peux enlever ces deux lignes si pas nécessaires dans le footer
            // this._hideAsideOverlay();
            // this._hideOverlay();

            this._changeDetectorRef.markForCheck();
        });
    }
}
